var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"mt-5 background"},[_c('email-signup'),(!_vm.calculatePressed)?_c('div',[_c('calculator-input')],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }